import { Component, Inject, Optional } from '@angular/core';
import { trackByIndex } from '@y42/angular/util';
import { Y42FeatureType } from '@y42/json-schema';
import { HotToastRef } from '@y42/toast';
import { Y42FeatureTypeToRoute, Y42RouteDetailTabs, Y42RouterService } from '../../../routing';

@Component({
  selector: 'y42-import-template-toast-message',
  template: `
    <p><strong>Template import is successful</strong></p>
    <p>Select individual data sources and authenticate your integrations:</p>
    <p *ngFor="let integration of integrations; trackBy: trackByIndex">
      <a target="_blank" rel="noopener noreferrer" [href]="integration.link">{{ integration.id }}</a>
    </p>
  `,
})
export class ImportTemplateToastMessageComponent {
  constructor(
    @Optional() @Inject(HotToastRef) public toastRef: HotToastRef<{ integrationsToAuthorize: string[] }>,
    private readonly router: Y42RouterService,
  ) {}

  readonly integrations = this.toastRef.data.integrationsToAuthorize.map((id) => ({
    id,
    link: this.router.getURLToDetail(
      Y42FeatureTypeToRoute[Y42FeatureType.Integration],
      id,
      Y42RouteDetailTabs.Overview,
    ),
  }));

  readonly trackByIndex = trackByIndex<{ id: string; link: string }>;
}
